import styled from 'styled-components'
import { font, spacing } from '@chegg-ui/theme'
import { Button, SecondaryButton } from '@chegg-ui/button'
import { ShimmerBodyText } from '@chegg-ui/shimmer'
import { Typography } from '@chegg-ui/typography'
import { REWRITE_PANEL_WIDTH } from '../Layout/styled'
import { DiffHighlight } from '../CardsContainer/SuggestionTabs/utils'

interface ErrorStateProps {
  error?: boolean
  isUndoRedoEnabled?: boolean
}

export const QuickActionRightPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${REWRITE_PANEL_WIDTH}px;
  border-top-left-radius: 20px;
  box-shadow: -1px -1px 8px 0 #e2e1e6;
  padding: ${spacing.px32} ${spacing.px24} 20px ${spacing.px24};
  box-sizing: border-box;
`
export const QuickActionRightPanelIcons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing.px16};
`
export const QuickActionRightPanelContent = styled.div<ErrorStateProps>`
  flex-grow: 1;
  padding-top: ${({ error }) => (error ? `${spacing.px8} 0` : `${spacing.px16} 0`)};
  height: ${({ isUndoRedoEnabled }) =>
    isUndoRedoEnabled
      ? `calc(100vh - 350px)`
      : `calc(100vh - 290px)`}; /*In undo redo, footer disclaimer takes more space*/
  overflow-y: auto;
`

export const QuickActionRightPanelDiffText = styled(DiffHighlight)`
  font-size: ${spacing.px16};
  line-height: ${spacing.px32};
`

export const QuickActionRightPanelFooterButtons = styled.div`
  display: flex;
  gap: ${spacing.px12};
  margin-top: ${spacing.px8};
`

export const UpdatePanelButton = styled(Button)`
  min-width: ${spacing.px160};
`
export const TryAgainPanelButton = styled(SecondaryButton).attrs({
  variant: 'outlined',
})`
  min-width: ${spacing.px160};
`

export const ShimmerQARightPanel = styled(ShimmerBodyText).attrs({
  line: 5,
})`
  height: 22px;
  &:not(:first-child) {
    margin-top: ${spacing.px16};
  }
  &:nth-child(1) {
    width: 88%;
  }
  &:nth-child(2) {
    width: 95%;
  }
  &:nth-child(3) {
    width: 96%;
  }
  &:nth-child(4) {
    width: 87%;
  }
  &:nth-child(5) {
    width: 75%;
  }
`
export const QuickActionRightPanelHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const QuickActionRightPanelSubHeading = styled(Typography).attrs({
  variant: 'body2',
  variantType: 'paragraph',
})`
  width: 368px;
  height: 20px;
  color: #928e9f;
  margin-bottom: ${spacing.px24};
`

export const Header = styled.div<ErrorStateProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ error }) => (error ? '#e5222f' : '#333333')};
  gap: ${spacing.px8};
  > span {
    font-size: ${font.size.px16};
    font-weight: ${font.weight.bold};
  }
`
